import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Spinner,
  Progress,
  Table,
  Input,
} from "reactstrap";
import { Preview } from "../../../../helpers/ui/FileInput";

import { Link } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/kepegawaian/menuService";

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";

import UpdateBloc from "../Update/Blocs/UpdateBloc";
import moment from "moment";

const jobType = [
  { value: 1, label: "PNS BKPM" },
  { value: 2, label: "PNS Non BKPM" },
  { value: 3, label: "Non PNS" },
  { value: 4, label: "Belum Bekerja" },
];

class DetailView extends Component {
  source;
  updateBloc = new UpdateBloc();
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      detail: [],
      isLocal: 1,
      pnsStatus: 1,
      peg_uuid: "",
    };
  }

  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));

  titleCase = (s) =>
    s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
      c ? c.toUpperCase() : " " + d.toUpperCase()
    );

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadDetail = async () => {
    const query = {
      id: this.props.id,
    };
    await this.updateBloc.fetchDetail(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadDetail();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            detail: result.data.response,
            isLocal:
              result.data.response.family.family_place_of_birth_national ==
              "Luar Negeri"
                ? 0
                : 1,
            pnsStatus: result.data.response.family.family_spouse_job_type,
            documents: result.data.response?.family.documents,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.updateBloc.detailChannel?.unsubscribe();
  }

  render() {
    const { detail, family } = this.state.detail;
    const currentJob = jobType.filter(
      (opt) => opt.value == family?.family_spouse_job_type
    )[0];

    const peg_uuid =
      this.employeeSeleted?.employee_uuid ?? this.userdata?.employee_uuid ?? "";
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <PegawaiSideBar active="riwayat_nikah" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <div className="float-end">
                    <Link to={`?riwayat_nikah`}>
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Detail Suami/Istri</CardTitle>
                  <hr />
                  <Row>
                    <Col md="6">
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Jenis Pekerjaan :{" "}
                        </Label>
                        <Label className="col-md-4 col-form-label">
                          {currentJob?.label}
                        </Label>
                      </Row>

                      {/* {(this.state.pnsStatus === "1" ||
                        this.state.pnsStatus === "2") && (
                        <Row className="mb-1">
                          <Label className="col-md-3 col-form-label">
                            NIP :{" "}
                          </Label>
                          <Label className="col-md-8 col-form-label">
                            {family?.family_profession_pns_nip}{" "}
                          </Label>
                        </Row>
                      )} */}

                      {(this.state.pnsStatus === "1" ||
                        this.state.pnsStatus === "2") && (
                        <Row className="mb-1">
                          <Label className="col-md-3 col-form-label">
                            NIP :
                          </Label>
                          <Label className="col-md-8 col-form-label">
                            {(() => {
                              if (peg_uuid === family?.family_employee_uuid) {
                                return (
                                  family?.family_couple_employee_nip ||
                                  family?.family_profession_pns_nip ||
                                  "-"
                                );
                              }

                              if (
                                peg_uuid === family?.family_couple_employee_uuid
                              ) {
                                return (
                                  family?.family_employee_nip ||
                                  family?.family_profession_pns_nip ||
                                  "-"
                                );
                              }

                              return family?.family_profession_pns_nip || "-";
                            })()}
                          </Label>
                        </Row>
                      )}

                      {/* {family?.family_spouse_job_type == "3" &&
                                                <Row className="mb-3">
                                                    <label className="col-md-3">
                                                        Pekerjaan
                                                    </label>
                                                    <Col md="9">
                                                        {
                                                            family ?
                                                                <>{family.family_profession !== "" ? family.family_profession : '-'}</>
                                                            :
                                                                <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                        }
                                                    </Col>
                                                </Row>
                                            } */}
                      {this.state.pnsStatus !== "1" && (
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label"></Label>
                          <Col md="8" style={{ paddingTop: "8px" }}>
                            <Input
                              type="checkbox"
                              checked={
                                family?.family_is_dependent_allowance == 1
                              }
                              disabled
                            />
                            <span style={{ marginLeft: "8px" }}>
                              Apakah pasangan sudah dapat tunjangan keluarga di
                              tempat lain?
                            </span>
                          </Col>
                        </Row>
                      )}

                      {/* <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Nama Suami/Istri :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_name}{" "}
                        </Label>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Nama Suami/Istri :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_name ||
                                family?.family_name ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_employee_name ||
                                family?.family_name ||
                                "-"
                              );
                            }

                            return family?.family_name || "-";
                          })()}
                        </Label>
                      </Row>

                      <Row className="mb-3">
                        <label className="col-md-3">
                          Nomor Induk Kependudukan :
                        </label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_identity_number}{" "}
                        </Label>
                      </Row>
                      <Row className="mb-3">
                        <label className="col-md-3">
                          Nomor Kartu Keluarga :
                        </label>
                        <Label className="col-md-8 col-form-label">
                          {family?.familty_family_card_number}{" "}
                        </Label>
                      </Row>

                      {/* <Row className="mb-3">
                        <label className="col-md-3">
                          Tempat Lahir Luar / Dalam Negeri
                        </label>
                        <Col md="9">
                          {family ? (
                            <>
                              {family.family_place_of_birth_national !== ""
                                ? family.family_place_of_birth_national
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "40%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Tempat Lahir Luar / Dalam Negeri :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_place_of_birth_national ||
                                family?.family_place_of_birth_national ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_region_national ||
                                family?.family_place_of_birth_national ||
                                "-"
                              );
                            }

                            return (
                              family?.family_place_of_birth_national || "-"
                            );
                          })()}
                        </Label>
                      </Row>

                      {/* <Row className="mb-3">
                        <label className="col-md-3">Negara Lahir</label>
                        <Col md="9">
                          {family ? (
                            <>
                              {family.family_place_of_birth_country_name !== ""
                                ? family.family_place_of_birth_country_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "40%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Negara Lahir :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_place_of_birth_country_name ||
                                family?.family_place_of_birth_country_name ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_region_country ||
                                family?.family_place_of_birth_country_name ||
                                "-"
                              );
                            }

                            return (
                              family?.family_place_of_birth_national || "-"
                            );
                          })()}
                        </Label>
                      </Row>

                      {/* <Row
                        className="mb-3"
                        style={
                          this.state.isLocal == 0 ? { display: "none" } : {}
                        }
                      >
                        <label className="col-md-3">Provinsi Lahir</label>
                        <Col md="9">
                          {family ? (
                            <>
                              {family.family_place_of_birth_province_name !== ""
                                ? family.family_place_of_birth_province_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "40%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Provinsi Lahir :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_place_of_birth_province_name ||
                                family?.family_place_of_birth_province_name ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_region_province ||
                                family?.family_place_of_birth_province_name ||
                                "-"
                              );
                            }

                            return (
                              family?.family_place_of_birth_province_name || "-"
                            );
                          })()}
                        </Label>
                      </Row>

                      {/* <Row
                        className="mb-3"
                        style={
                          this.state.isLocal == 0 ? { display: "none" } : {}
                        }
                      >
                        <label className="col-md-3">Kota Lahir</label>
                        <Col md="9">
                          {family ? (
                            <>
                              {family.family_place_of_birth_city_name !== ""
                                ? family.family_place_of_birth_city_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "40%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row> */}

                      {/* <Row
                        className="mb-3"
                        style={
                          this.state.isLocal == 1 ? { display: "none" } : {}
                        }
                      >
                        <label className="col-md-3">Kota Lahir</label>
                        <Col md="9">
                          {family ? (
                            <>
                              {family.family_place_of_birth_city_text !== ""
                                ? family.family_place_of_birth_city_text
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "40%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Kota Lahir :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_place_of_birth_city_name ||
                                family?.family_place_of_birth_city_name ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_region_city ||
                                family?.family_place_of_birth_city_name ||
                                "-"
                              );
                            }

                            return (
                              family?.family_place_of_birth_city_name || "-"
                            );
                          })()}
                        </Label>
                      </Row>

                      {/* <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Tanggal Lahir :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {this.dateParse(family?.family_date_of_birth)}{" "}
                        </Label>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Tanggal Lahir :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_date_of_birth ||
                                family?.family_date_of_birth ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_region_date_of_birth ||
                                family?.family_date_of_birth ||
                                "-"
                              );
                            }

                            return family?.family_date_of_birth || "-";
                          })()}
                        </Label>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Status :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {detail?.relationship_status}{" "}
                        </Label>
                      </Row>
                      {/* <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Pendidikan :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_education_name}{" "}
                        </Label>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Pendidikan :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_education_name ||
                                family?.family_education_name ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_education ||
                                family?.family_education_name ||
                                "-"
                              );
                            }

                            return family?.family_education_name || "-";
                          })()}
                        </Label>
                      </Row>

                      {/* <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Jurusan :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_major}{" "}
                        </Label>
                      </Row> */}

                      <Row className="mb-1">
                        <Label className="col-md-3 col-form-label">
                          Jurusan :
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {(() => {
                            if (peg_uuid === family?.family_employee_uuid) {
                              return (
                                family?.family_major ||
                                family?.family_major ||
                                "-"
                              );
                            }

                            if (
                              peg_uuid === family?.family_couple_employee_uuid
                            ) {
                              return (
                                family?.family_education_background ||
                                family?.family_major ||
                                "-"
                              );
                            }

                            return family?.family_major || "-";
                          })()}
                        </Label>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Tempat Kerja :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_profession_place}{" "}
                        </Label>
                      </Row>
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Pekerjaan :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_profession}{" "}
                        </Label>
                      </Row>
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Sebagai Ahli Waris :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_spouse_is_heir === 1 ? "Ya" : "Tidak"}{" "}
                        </Label>
                      </Row>
                      {family?.family_spouse_is_heir == 1 && (
                        <Fragment>
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Sudah Dibayar :{" "}
                            </Label>
                            <Label className="col-md-3 col-form-label">
                              {family?.family_spouse_is_pay === 1
                                ? "Ya"
                                : "Tidak"}{" "}
                            </Label>
                          </Row>
                          {family?.family_spouse_is_pay == 1 && (
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Bulan Dibayar :{" "}
                              </Label>
                              <Label className="col-md-3 col-form-label">
                                {family?.family_spouse_pay_date}
                              </Label>
                            </Row>
                          )}
                        </Fragment>
                      )}
                    </Col>

                    <Col md="6">
                      <CardTitle>Keterangan Nikah</CardTitle>
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Nikah Ke :{" "}
                        </Label>
                        <Label className="col-md-4 col-form-label">
                          {family?.family_spouse_marriage_count}{" "}
                        </Label>
                      </Row>
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Tanggal Nikah :{" "}
                        </Label>
                        <Label className="col-md-4 col-form-label">
                          {this.dateParse(family?.family_spouse_wedding_date)}{" "}
                        </Label>
                      </Row>
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Suami/Istri ke :{" "}
                        </Label>
                        <Label className="col-md-2 col-form-label">
                          {family?.family_spouse_husband_or_wife_to}{" "}
                        </Label>
                      </Row>
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          No Buku/Akta Nikah :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_spouse_marriage_book_number}{" "}
                        </Label>
                      </Row>
                      {/* <Row className="mb-3">
                                                <Label className="col-md-3 col-form-label">Kartu Nikah : </Label>
                                                <Label className="col-md-8 col-form-label"> </Label>
                                            </Row> */}
                      <hr />

                      {detail?.relationship_status != "Nikah" && (
                        <Fragment>
                          <CardTitle>Keterangan Cerai</CardTitle>
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Tanggal Cerai :{" "}
                            </Label>
                            <Label className="col-md-4 col-form-label">
                              {this.dateParse(
                                family?.family_spouse_divorce_date
                              )}{" "}
                            </Label>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              No SK Cerai :{" "}
                            </Label>
                            <Label className="col-md-8 col-form-label">
                              {family?.family_spouse_divorce_number_decree}{" "}
                            </Label>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              TMT SK Cerai :{" "}
                            </Label>
                            <Label className="col-md-4 col-form-label">
                              {family?.family_spouse_divorce_tmt_date}{" "}
                            </Label>
                          </Row>
                          <hr />
                        </Fragment>
                      )}
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          No Karis / Karsu :{" "}
                        </Label>
                        <Label className="col-md-8 col-form-label">
                          {family?.family_spouse_karis_karsu_number}{" "}
                        </Label>
                      </Row>

                      {/* <Row className="mb-3">
                                                <Label className="col-md-3 col-form-label">File Pendukung : </Label>
                                                <Preview value={family?.document } />
                                           </Row> */}

                      <hr />

                      {this.state.documents?.map((val, i) => {
                        return (
                          <Row className="mb-3">
                            <label className="col-md-3">
                              {this.titleCase(val.family_document_type)}
                            </label>
                            <Col md="9">
                              {val.document ? (
                                <Preview value={val.document} />
                              ) : (
                                <Shimmer>
                                  <div style={{ width: 68, height: 15 }}></div>
                                </Shimmer>
                              )}
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default DetailView;
